import * as yup from "yup";

import type { TFunction } from "i18next";

/** Valores validados del formulario de completar horas faltantes. */
export interface MissingHourValues {
  activityId: string;
  spentOn: Date;
  comment: string;
}

/**
 * Construye el schema de validación para completar horas faltantes.
 */
export const buildMissingHourSchema = (t: TFunction): yup.ObjectSchema<MissingHourValues> =>
  yup.object().shape({
    activityId: yup.string().typeError(t("isRequired")).required(t("isRequired")),
    spentOn: yup.date().typeError(t("isRequired")).required(t("isRequired")),
    comment: yup.string().typeError(t("isRequired")).required(t("isRequired")),
  }).required();
